export default "__VITE_ASSET__DCqXJhhW__"